import findBySlug from "./find-by-slug";

const findSeason = (volume, route) =>
  findBySlug(volume?.seasons, route.params.seasonSlug);

export default function resolveRoutedSeason(route, parentVolume, { getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // If no season slug route parameter is provided, we fall back
  // to the auto season, which might be the current season
  // (if the current volume is selected and the current date
  // falls into one of this volume's seasons); might be
  // the first season of the selected volume; might
  // be null in all other cases.
  if (!route.params?.seasonSlug) {
    return null;
  }

  // If a season slug route parameter is provided, we use this
  // parameter to match one of the selected volume's seasons.
  // If none matches because the season slug route param
  // is invalid, then an automatic fallback is chosen.
  return findSeason(parentVolume, route);
}
